import type React from 'react';
import ReactMarkdown from 'react-markdown';
import {CommonLink} from '../../../../shared/components/CommonLink';
import styles from './MarkdownText.module.css';

export const MarkdownText: React.FC<{
  children?: string;
}> = ({children}) => {
  return (
    <ReactMarkdown
      className={styles.markdown}
      components={{
        a: ({node, href, ...props}) =>
          href?.match(/^https?:\/\//) ? (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {props.children}
            </a>
          ) : (
            <CommonLink href={href!}>{props.children}</CommonLink>
          ),
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
